import { AllSet } from "./AllSet";

export default AllSet;